<div class="row">
  <div class="col-12">
    <button [routerLink]="['/licitacoes-audesp', registroPreco, ajuste, 'empenho', 'novo']"
      routerLinkActive="router-link-active" class="btn btn-sm btn-primary"
      style="margin-top: -5px; margin-bottom: 10px;">
      <i class="fa fa-plus"></i> Incluir
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md">
    <div class="table-responsive">
      <table class="table table-eddy table-sm">
        <thead>
          <tr>
            <th scope="col" class="text-center">Código</th>
            <th scope="col" class="text-center">Tipo</th>
            <th scope="col" class="text-center">Identificação</th>
            <th scope="col" class="text-center">Exportado</th>
            <th scope="col" class="text-center">Enviado</th>
            <th scope="col" class="text-center">Armazenado</th>
            <th scope="col" style="width: 90px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaEmpenho">
            <th scope="row" class="text-center" style="width: 120px">{{item.codigo}}</th>
            <td class="text-center">
              <span class="badge badge-primary">{{item.tipo}}</span>
            </td>
            <td class="text-center">
              {{item.identificacao}}
            </td>
            <td class="text-center">
              <span [class]="'badge badge-' + (item.exportado ? 'success' : 'secondary')">
                {{item.exportado ? 'Sim': 'Não'}}
              </span>
            </td>
            <td class="text-center">
              <span [class]="'badge badge-' + (item.enviado ? 'success' : 'secondary')">
                {{item.enviado ? 'Sim': 'Não'}}
              </span>
            </td>
            <td class="text-center">
              <span [class]="'badge badge-' + (item.armazenado ? 'success' : 'secondary')">
                {{item.armazenado ? 'Sim': 'Não'}}
              </span>
            </td>
            <td class="text-right">
              <button [routerLink]="['/licitacoes-audesp', registroPreco, ajuste, 'empenho', item.id, 'editar']"
                routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary mr-2">
                <i class="fa fa-search"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>